/**
 * 애플리케이션 진입점 (Entry Point)
 * React 앱을 DOM에 마운트하는 역할을 수행합니다.
 * react-snap을 통한 사전 렌더링(pre-rendering)을 지원합니다.
 */

import React from "react";
import { createRoot } from "react-dom/client";
import { hydrateRoot } from "react-dom/client";
import Main from "./Main";

// root 엘리먼트 가져오기
const container = document.getElementById("root");
const root = createRoot(container);

/**
 * react-snap으로 사전 렌더링된 경우 hydrate를 사용하고,
 * 일반적인 경우 render를 사용합니다.
 *
 * - hasChildNodes(): react-snap이 미리 렌더링한 HTML이 있는지 확인
 * - hydrateRoot(): 사전 렌더링된 HTML에 React 이벤트 리스너를 부착
 * - render(): 처음부터 React 컴포넌트를 렌더링
 */
if (container.hasChildNodes()) {
  // 사전 렌더링된 HTML이 있는 경우: hydrate 사용
  hydrateRoot(container, <Main />);
} else {
  // 사전 렌더링된 HTML이 없는 경우: 일반 render 사용
  root.render(<Main />);
}
